

































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { debounce } from "@/services/utils";

@Component
export default class Quantity extends Vue {
  quantity = "1";
  debouncedSetter = debounce(this.setQuantity, 500);
  tooltip = false;
  timeout: any = null;

  readyToShowTooltip = false;

  @Prop({ type: String, default: "table" })
  readonly type!: string;

  @Prop({ type: String, default: "" })
  readonly tooltipText!: string;

  @Prop({ type: Number, default: 1 })
  readonly value!: number;

  @Prop({ type: Number, default: 999 })
  readonly max!: number;

  @Prop({ type: Function, default: () => null })
  readonly changeHandler!: (quantity: number) => void;

  get isMin() {
    return parseInt(this.quantity, 10) <= 1;
  }

  get isMax() {
    return (
      this.max !== undefined &&
      this.max !== null &&
      parseInt(this.quantity, 10) >= this.max
    );
  }

  created() {
    if (this.value > 1) {
      this.quantity = this.value.toString();
    }
  }

  @Watch("quantity")
  quantityWatcher(n: string) {
    const value = parseInt(n, 10);
    this.debouncedSetter(value);
  }

  @Watch("value")
  valueWatcher(n: number) {
    if (this.tooltipText && this.readyToShowTooltip) this.showTooltip(true);
    if (n && n.toString() !== this.quantity) {
      this.quantity = n.toString();
    }
  }

  setQuantity(n: number) {
    if (n && n !== this.value) {
      this.changeHandler(n);
    }
  }

  showTooltip(show: boolean) {
    if (this.tooltipText) {
      this.tooltip = show;
      clearTimeout(this.timeout);
      if (show) {
        this.timeout = setTimeout(() => {
          this.tooltip = false;
        }, 5000);
      }
    }
  }

  increment() {
    this.readyToShowTooltip = true;
    if (this.isMax) {
      this.showTooltip(true);
      return;
    }
    this.quantity = (parseInt(this.quantity, 10) + 1).toString();
  }

  decrement() {
    this.showTooltip(false);
    this.readyToShowTooltip = false;
    if (this.isMin) {
      return;
    }
    this.quantity = (parseInt(this.quantity, 10) - 1).toString();
  }

  setValue(e: any) {
    let value = 1;
    if (e.target.value) {
      value = parseInt(e.target.value, 10);
      if (this.max && value > this.max) {
        value = this.max;
        if (this.max < 999) this.showTooltip(true);
      } else if (!value) {
        value = 1;
      }
    }
    this.quantity = value.toString();
  }
}
